import { axiosPrivate } from "../../api/axios";

const getMaintenanceStatus = async () => {
  const response = await axiosPrivate.get(`/setting/status`);
  return response.data;
};

const settingService = {
  getMaintenanceStatus,
};

export default settingService;
